import { useDispatch, useSelector } from "react-redux";
import { toggleAccionDesarrolloActiveThunk } from "../../store/reducers/fortalezas/fortalezas.thunks";
import Modal from "../UI/Modal";
import Loader from "../UI/Loader";
import { closeAccionConfirmToggle } from "../../store/reducers/fortalezas/fortalezas.reducer";

const ConfirmToggleAccionModal = () => {
  const dispatch = useDispatch();
  const { accionConfirmModalOpen, toggleAccionId, accionToggling } = useSelector(
    (state) => state.fortalezas
  );

  const accion = useSelector((state) =>
    state.fortalezas.accionesList.find((a) => a.id === toggleAccionId)
  );

  const handleConfirm = () => {
    dispatch(toggleAccionDesarrolloActiveThunk(toggleAccionId));
  };

  return (
    <Modal
      open={accionConfirmModalOpen}
      onClose={() => dispatch(closeAccionConfirmToggle())}
      title="Confirmación"
      size="sm"
    >
      {accionToggling ? (
        <Loader center text="Actualizando acción..." type="dots" size="sm" />
      ) : (
        <>
          <p className="mb-3">
            ¿Seguro que quieres{" "}
            <strong>{accion?.is_active ? "desactivar" : "activar"}</strong> la
            acción <strong>"{accion?.frase}"</strong>?
          </p>

          <div className="d-flex justify-content-end gap-2">
            <button
              className="btn btn-secondary"
              onClick={() => dispatch(closeAccionConfirmToggle())}
            >
              Cancelar
            </button>
            <button className="btn btn-primary" onClick={handleConfirm}>
              Confirmar
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ConfirmToggleAccionModal;
